import React from "react";

// Define a TypeScript type for props
interface NumberFormatProps {
  value: number | string;
  prefix?: string;
  suffix?: string;
  separator?: string;
  locale?: string;
}

const NumberFormat: React.FC<NumberFormatProps> = ({
  value,
  prefix = "",
  suffix = "",
  separator = ",",
  locale = "en-US",
}) => {
  // Make sure the value is a number
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  // If the value is not a valid number, return an empty string or custom fallback
  if (isNaN(numericValue)) {
    return (
      <span>
        {prefix}
        {suffix}
      </span>
    );
  }

  // Create a formatter with the specified separator
  const numberFormat = new Intl.NumberFormat(locale, {
    useGrouping: true, // Automatically adds grouping separators (e.g., commas)
  });

  // Format the number and replace the default separator with the custom separator
  const formattedValue = numberFormat
    .format(numericValue)
    .replace(",", separator);

  return (
    <span>
      {prefix}
      {formattedValue}
      {suffix}
    </span>
  );
};

export default NumberFormat;
